export function preloadImage(url) {
  if (!url) return Promise.resolve();
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = resolve;
    img.onerror = resolve;
    img.src = url;
  });
}

export function preloadImages(urls) {
  const list = (urls || []).filter(Boolean);
  if (!list.length) return Promise.resolve();
  return Promise.all(list.map((url) => preloadImage(url)));
}
